$('[data-product-slider]').slick({
    dots: true,
    infinite: true,
    speed: 800,
    slidesToShow: 1,
    adaptiveHeight: false,
    arrows: false,
    draggable: true,
    autoplay: true,
    autoplaySpeed: 10000,
});
